import { LayoutService } from './layout.service';
import { NavigationService } from './navigation.service';
import { SideNavService } from './side-nav.service';

export const services = [NavigationService, SideNavService, LayoutService];

export * from './layout.service';
export * from './navigation.service';
export * from './side-nav.service';
